<template>
  <b-modal
    v-model="showModal"
    title="Delete Question"
    centered
    size="md"
    ok-title="Delete Question"
    cancel-title="Cancel"
    @hidden="onHide"
    @ok="onOk"
  >
    <p>This will permanently delete this question. Are you sure you want to continue?</p>
  </b-modal>
</template>

<script>
export default {
  props: {
    visible: {type: Boolean,required: true},
    question: {type: Object, default: null}
  },
  data() {
    return {}
  },
  computed: {
    showModal: {
      get() {
        return this.visible
      },
      set(newValue) {
        this.modalIsVisible = newValue
      }
    }
  },
  methods: {
    onOk(){
      this.$emit('onDelete', this.question)
    },
    onHide(){
      this.$emit('onCancel', this.question)
    }

  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/questions/deleteModal.vue